import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import "./IECVideoModal.scss";
import { useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";
import { getIecData } from "../../Store/IECModule/IECModuleSelector";
import { useDispatch, useSelector } from "react-redux";
import deleteIconImg from "../../Assets/deleteIcon.png";
import { deleteIECModule } from "../../Services/IECModuleService";
import {
  clearSelectedItems,
  fetchIECViewData,
} from "../../Store/IECModule/IECModuleAction";
import { useLanguage } from "../ChangeLanguage/LanguageProvider";
import { Button } from "primereact/button";

export default function IECDeleteModal() {
  const [visible, setVisible] = useState(true);
  const [videoData, setVideoData] = useState(null);

  const [serachParams] = useSearchParams();
  const iecDataId = serachParams.get("delete");

  const navigate = useNavigate();
  const { selectedLanguageId } = useLanguage();
  const dispatch = useDispatch();
  const fetchedData = useSelector(getIecData);
  useEffect(() => {
    if (iecDataId) {
      const id = parseInt(iecDataId);
      setVisible(true);
      setVideoData(fetchedData.find((data) => data.id === id));
    }
  }, [iecDataId, fetchedData]);

  const onHide = () => {
    setVisible(false);
    navigate("/iecmodule");
  };
  const onDelete = async () => {
    await deleteIECModule(iecDataId);
    setVisible(false);
    navigate("/iecmodule");
    await fetchIECViewData(dispatch, selectedLanguageId)();
    dispatch(clearSelectedItems());
  };
  if (!videoData) return null;

  return (
    <>
      <Dialog
        className="delete-main-head"
        header={
          <div className="delete-main">
            <img
              src={deleteIconImg}
              alt="Delete Icon"
              className="delete-icon"
              data-testid="Deletevideo-modal"
            />
            Delete Video Module
          </div>
        }
        data-testid="video-modal"
        visible={visible}
        onHide={onHide}
      >
        <div className="delete-container">
          <div className="delete-videoDes">
            <video
              id="videoPlayerDelete"
              height="auto"
              controls={false}
              poster={videoData.thumbnail}
            >
              <source src={videoData.videoUrl} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <div className="DeletePlay-button"></div>
            <div className="delete-videodata">
              <p className="delete-videoTitle">
                {selectedLanguageId === 1
                  ? videoData.videoTitle.english
                  : videoData.videoTitle.marathi}
              </p>
              <ul className="delete-categoryType">
                {Array.isArray(videoData.categoryType) ? (
                  videoData.categoryType.map((category) => (
                    <li key={category}>{category}</li>
                  ))
                ) : (
                  <li>{videoData.categoryType}</li>
                )}
              </ul>
              <p style={{ marginTop: "1%" }}>
                <span style={{ fontWeight: "500" }}>Description-</span>{" "}
                {videoData.videoDescription}
              </p>
            </div>
          </div>
          <p className="delete-infor">
            Are you sure you want to delete this Video Module? This action
            cannot be <br></br>undone.
          </p>
          <div className="delete-button-container">
            <Button
              className="delete-cancel"
              data-testid="close-modal"
              onClick={onHide}
              tooltip="Cancel"
              tooltipOptions={{ position: "bottom", event: "both" }}
            >
              Cancel
            </Button>
            <Button
              className="delete-confirm"
              data-testid="delete-modal"
              onClick={onDelete}
            >
              Delete Video Module
            </Button>
          </div>
        </div>
      </Dialog>
    </>
  );
}
